"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AnalyticsProvider: function() {
        return AnalyticsProvider;
    },
    useInternalAnalyticsClient: function() {
        return useInternalAnalyticsClient;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const AnalyticsContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
function useInternalAnalyticsClient() {
    const context = (0, _react.useContext)(AnalyticsContext);
    if (!context) {
        throw new Error('useInternalAnalyticsClient must be used within an AnalyticsProvider');
    }
    return context;
}
function AnalyticsProvider({ children, createClient, env, isSSR, globalizationPair, geoIPCountry }) {
    const client = (0, _react.useMemo)(()=>createClient({
            env,
            isSSR,
            globalizationPair,
            geoIPCountry
        }), [
        createClient,
        env,
        isSSR,
        globalizationPair,
        geoIPCountry
    ]);
    return /*#__PURE__*/ _react.default.createElement(AnalyticsContext.Provider, {
        value: client
    }, children);
}

//# sourceMappingURL=AnalyticsProvider.js.map